import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {SkuCategoryTotalType, SkuFoodCategoryCountType, SkuFoodCategoryType, SkuSvTableType} from "../common/types";
import {loadingTablesAC, setErrorAC} from "./authReducer";
import {AxiosError} from "axios";
import {skuFoodApi} from "../api/skuFood";
import {endDS, startDS, startSFCatOneBlock, startSFCatTwoBlock} from "../common/optionsForDate";

type InitialStateType = {
    date: string[],
    city: string,
    store_name: string,
    level_category: string

    dateSvTable: string[]
    citySvTable: string,
    store_nameSvTable: string

    dataSvTable: SkuSvTableType[] | null

    categoryCountData: SkuFoodCategoryCountType[] | null
    categoryData: SkuFoodCategoryType[] | null
    categoryTotalForBlockOne: SkuCategoryTotalType[] | null
    categoryTotalForBlockTwo: SkuCategoryTotalType[] | null
}

export const slice = createSlice({
    name: 'categoryFood',
    initialState: {
        date: [startSFCatOneBlock, endDS],
        city: 'Москва',
        store_name: 'Яндекс Лавка',
        level_category: 'Левел 1 Самокат',


        dateSvTable: [startSFCatTwoBlock, endDS],
        citySvTable: 'Москва',
        store_nameSvTable: 'Ozon Fresh',

        dataSvTable: null,

        categoryCountData: null,
        categoryData: null,
        categoryTotalForBlockOne: null,
        categoryTotalForBlockTwo: null,


    } as InitialStateType,
    reducers: {
        changeDateCFAC(state, action) {
            state.date = action.payload
        },
        changeCityCFAC(state, action) {
            state.city = action.payload
        },
        changeSpmCFAC(state, action) {
            state.store_name = action.payload
        },
        changeLevelCFAC(state, action) {
            state.level_category = action.payload
        },


        changeDateSvTableAC(state, action) {
            state.dateSvTable = action.payload
        },
        changeCitySvTabAC(state, action) {
            state.citySvTable = action.payload
        },
        changeSpmSvTabAC(state, action) {
            state.store_nameSvTable = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSkuFoodCategoryCount.fulfilled, (state, action) => {
                state.categoryCountData = action.payload
            })
            .addCase(fetchSkuFoodCategoryTC.fulfilled, (state, action) => {
                state.categoryData = action.payload
            })
            .addCase(fetchSkuFoodTotalTC.fulfilled, (state, action) => {
                if (action.meta.arg.block === 'one') state.categoryTotalForBlockOne = action.payload
                if (action.meta.arg.block === 'two') state.categoryTotalForBlockTwo = action.payload

            })
            .addCase(fetchSkuFoodSvTableTC.fulfilled, (state, action) => {
                state.dataSvTable = action.payload
            })

    }
})

export const fetchSkuFoodCategoryCount = createAsyncThunk('SkuFoodCategoryCount', async (param: {
    city: string,
    store_name: string,
    level_category: string,
    start_date_from: string,
    end_date_to: string
}, {dispatch, rejectWithValue}) => {

    try {
        const {city, start_date_from, end_date_to, level_category, store_name} = param
        const res = await skuFoodApi.getSkuFoodCategoryCount(start_date_from, end_date_to, city, store_name, level_category)
        return res.data.results.sort((a: SkuFoodCategoryCountType, b: SkuFoodCategoryCountType) => {
            if (a.name_category.length > b.name_category.length) {
                return 1;
            }
            if (a.name_category.length < b.name_category.length) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        })
    } catch (err) {
        dispatch(loadingTablesAC('failed'))
        const error = err as AxiosError

        if (!error.response) {
            throw err
        }
        dispatch(setErrorAC(error.response.status))
        return rejectWithValue(error.response)

    }
})

export const fetchSkuFoodCategoryTC = createAsyncThunk('SkuFoodCategory', async (param: {
    city: string,
    store_name: string,
    start_date_from: string,
    end_date_to: string
}, {dispatch, rejectWithValue}) => {

    try {
        const {city, start_date_from, end_date_to, store_name} = param
        const res = await skuFoodApi.getSkuFoodCategory(start_date_from, end_date_to, city, store_name)
        return res.data.results
    } catch (err) {
        dispatch(loadingTablesAC('failed'))
        const error = err as AxiosError

        if (!error.response) {
            throw err
        }
        dispatch(setErrorAC(error.response.status))
        return rejectWithValue(error.response)

    }
})

export const fetchSkuFoodTotalTC = createAsyncThunk('SkuFoodTotal', async (param: {
    city: string,
    store_name: string,
    start_date_from: string,
    end_date_to: string,
    block: string
    address: string
}, {dispatch, rejectWithValue}) => {

    try {
        const {city, start_date_from, end_date_to, store_name, address} = param
        const res = await skuFoodApi.getSkuFoodTotal(start_date_from, end_date_to, city, store_name, address)
        return res.data.results

    } catch (err) {
        dispatch(loadingTablesAC('failed'))
        const error = err as AxiosError

        if (!error.response) {
            throw err
        }
        dispatch(setErrorAC(error.response.status))
        return rejectWithValue(error.response)

    }
})

export const fetchSkuFoodSvTableTC = createAsyncThunk('SkuFoodSvTable', async (param: {
    city: string,
    store_name: string,
    start_date_from: string,
    end_date_to: string
}, {dispatch, rejectWithValue}) => {

    try {
        const {city, start_date_from, end_date_to, store_name} = param
        const res = await skuFoodApi.getSkuFoodSvTable(start_date_from, end_date_to, city, store_name)

        const parseWeekNumber = (weekStr: string) => {
            const [week, year] = weekStr.split('_').map(Number);
            return {week, year};
        };

        // Сортировка по week_number
        return [...res.data.results].sort((a, b) => {
            const weekA = parseWeekNumber(a.week_number);
            const weekB = parseWeekNumber(b.week_number);

            // Сначала сравниваем год
            if (weekA.year !== weekB.year) {
                return weekA.year - weekB.year;
            }

            // Если год одинаковый, сравниваем номер недели
            return weekA.week - weekB.week;
        }).map((el: SkuSvTableType) => ({
            ...el,
            level_3: el.level_3.replace('лелвел', 'левел')
        }))


    } catch (err) {
        dispatch(loadingTablesAC('failed'))
        const error = err as AxiosError

        if (!error.response) {
            throw err
        }
        dispatch(setErrorAC(error.response.status))
        return rejectWithValue(error.response)

    }
})

export const categoryFoodReducer = slice.reducer
export const {
    changeDateCFAC,
    changeCityCFAC,
    changeSpmCFAC,
    changeLevelCFAC,
    changeDateSvTableAC,
    changeSpmSvTabAC,
    changeCitySvTabAC
} = slice.actions